import React, { useMemo } from 'react';
import { createUseStyles } from 'react-jss';
import hoistNonReactStatics from 'hoist-non-react-statics';

const emptyTheme = { components: {}, core: {} };
const getDisplayName = Component => Component.displayName || Component.name || 'Component';

// the purpose of the hoc is to deouple the wrapped components with a specific theme provider,
// to make the library as independent as possible

// use an external theme to decouple the wrapped components with a specific theme provider
export function withThemedStyles(WrappedComponent, getStyles, options) {
  const {
    prefixClassName, // the prefix of the class names generated by react-jss
    useRawStyles, // also pass down the themed styles to the wrapped component, which may be used in Fluent UI components
    componentName, // the description name of WrappedComponent
  } = options || {};

  const HOC = (props) => {
    // the theme is passed as a prop to the wrapped component, instead of getting if from some theme provider
    const { theme } = props;
    const { components, core } = theme || emptyTheme;
    // handle theme by ourselves instead of using the react-jss theming
    const themedStyles = useMemo(() => getStyles(components, core), [components, core]);
    const useStyles = useMemo(() => createUseStyles(themedStyles, prefixClassName ? { name: prefixClassName } : undefined), [themedStyles]);
    const classes = useStyles() || {};
    return (
      <WrappedComponent {...props} classes={classes} themedStyles={useRawStyles ? themedStyles : undefined} />
    );
  };

  HOC.displayName = `withThemedStyles(${componentName || getDisplayName(WrappedComponent)})`;

  hoistNonReactStatics(HOC, WrappedComponent);

  return HOC;
}

export const withUAPLThemedStyles = (WrappedComponent, getStyles, options) => withThemedStyles(WrappedComponent, getStyles, { ...options, prefixClassName: 'UAPL' });

